<div #tableElement [hidden]="!active">
  <ng-content></ng-content>
</div>
